(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-v3"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSwiper(container) {
    if (!container || container.dataset.swiperInitialized === "true") return;
    if (typeof Swiper === 'undefined') return;

    const swiper = new Swiper(container, {
      loop: false,
      slidesPerView: 2,
      spaceBetween: 15,
      speed: 1200,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
      pagination: false,
      breakpoints: {
        640: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 }
      },
      on: {
        init: function () {
          container.dataset.swiperInitialized = "true";
        }
      }
    });
  }

  function tryInitSection() {
    document.querySelectorAll('.product-carousel').forEach(container => {
      initSwiper(container);
    });
  }

  document.addEventListener('DOMContentLoaded', tryInitSection);

  ['shopify:section:load', 'shopify:section:reorder', 'shopify:section:select', 'shopify:section:deselect']
    .forEach(eventName => {
      document.addEventListener(eventName, () => {
        setTimeout(tryInitSection, 100);
      });
    });

})();

  } catch(e) { console.error(e); }
})();
})();
